export default __webpack_public_path__ + "static/media/shutterstock_261385457.e4c82354.png";